import React from 'react';

// request-deletion
export default function DeleteAccount() {
  return (
    <div className="full-site">
       <h1 className="legal-title">
        Delete your Inner Reef account
      </h1>

      <p>
        To delete your account, you have two options:
      </p>

      <ol className="legal-list">
        <li>
          Email us at{' '}
          <a href="mailto:hello@innerreefapp.com">hello@innerreefapp.com</a>{' '}
          using the email you used to create your account.
        </li>
        <li>
          Or, simply open the Inner Reef app, go to the{' '}
          <strong>'Account & Subscription'</strong> section, tap{' '}
          <strong>'Delete Account'</strong>, and follow the instructions.
        </li>
      </ol>
    </div>
  );
}